import { createClient } from '@supabase/supabase-js';
import logger from '../utils/logger';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

// Log environment configuration
logger?.info('API', 'Supabase client initialization', {
  url: supabaseUrl ? `${supabaseUrl?.substring(0, 20)}...` : 'MISSING',
  anonKeyPresent: !!supabaseAnonKey,
  anonKeyLength: supabaseAnonKey?.length || 0
});

if (!supabaseUrl || !supabaseAnonKey) {
  logger?.error('API', 'Missing Supabase environment variables', {
    urlPresent: !!supabaseUrl,
    keyPresent: !!supabaseAnonKey
  });
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  }
});

logger?.info('API', 'Supabase client created successfully', {
  authConfig: {
    autoRefreshToken: true,
    persistSession: true
  }
});
